import React from 'react';
import { motion } from 'framer-motion';
export function PullQuote() {
  return <section className="py-32 px-6 bg-teal-900 text-cream text-center relative overflow-hidden" data-id="element-137">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold via-transparent to-transparent" data-id="element-138"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-140">
          <p className="text-xl md:text-2xl text-cream/80 leading-relaxed mb-6" data-id="element-141">
            Miles de personas viven atrapadas en silencio…
            <br data-id="element-142" />
            Pero cuando entiendes lo que realmente está pasando dentro de ti…
          </p>
          <p className="text-xl md:text-2xl text-gold italic" data-id="element-143">
            todo comienza a cambiar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="font-serif text-4xl md:text-5xl lg:text-7xl leading-tight" data-id="element-144">
          <h2 data-id="element-145">Sanar no es recuperar a alguien…</h2>
          <h2 className="text-terracotta italic mt-4" data-id="element-146">es recuperarte a ti.</h2>
        </motion.div>
      </div>
    </section>;
}